<template>
	<div>
		<button
			v-if="isFull"
			:class="`bottom_button button_3 ${disabled && 'button_disabled'}`"
			:disabled="disabled"
			@click="handleClick"
		>
			{{ label }}
		</button>
		<div v-else class="bottom_button_wrapper">
			<Button
				:label="label"
				:onClick="handleClick"
				:disabled="disabled"
				:size="56"
			/>
		</div>
	</div>
</template>

<script>
import Button from '../../components/ai/AiButton.vue'

export default {
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: '확인'
		},
		isFull: {
			type: Boolean,
			default: true
		},
		onClick: {
			type: Function,
			required: false
		}
	},
	components: {
		Button
	},
	methods: {
		handleClick(event) {
			if (this.onClick) {
				this.onClick(event)
			}
		}
	}
}
</script>

<style scope>
.bottom_button {
	position: fixed;
	bottom: 0;
	width: 100%;
	max-width: 768px;
	text-align: center;
	padding: 24px;
	color: var(--gray-scale-12);
	background-color: var(--primary-color-1);
	transition: background 0.3s;
}

.bottom_button_wrapper {
	position: fixed;
	bottom: 0;
	width: 100%;
	max-width: 768px;
	text-align: center;
	padding: 16px 20px 20px;
	background-color: var(--gray-scale-12);
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiBottomFloatButton.vue